import { render, staticRenderFns } from "./fall.vue?vue&type=template&id=1bf2ee3a&"
import script from "./fall.vue?vue&type=script&lang=js&"
export * from "./fall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports